import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ppl-view-deposit',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './view-deposit-entry.component.html',
  styleUrl: './view-deposit-entry.component.css'
})
export class ViewDepositEntryComponent {

}
